import React from "react";
import { PageList } from "../components/pageList";
import { ClaimTableSchema } from "../schema/table/claim";
import { ClaimAddForm, ClaimEditForm } from "../schema/form/claim";
import { useTableSchema } from "../hooks/useTableSchema";
import { useFormSchema } from "../hooks/useFormSchema";

const ProjectType = ({ title = "Project Type" }) => {
  const [getTableSchema] = useTableSchema();
  const [getFormSchema] = useFormSchema();

  return (
    <PageList
      title={title}
      apiEntity={"projectType"}
      tableSchema={getTableSchema("projectType")}
      formSchema={getFormSchema("projectType")}
      showImport={false}
      searchByTextField={true}
      showGoBack={true}
      backRoute="/setting"
      // stats={{
      //   component: ProjecPageStats,
      //   props: {
      //     mb: 35,

      //   },
      // }}
    />
  );
};

export default ProjectType;
